import CardMigrate from "../assets/card-migrate.png";
import CardTenant from "../assets/card-tenant.png";
import CardGuide from "../assets/card-guide.png";
import CardLessons from "../assets/card-lessons.png";
import CardDocs from "../assets/card-docs.png";
import CardPartner from "../assets/card-partner.png";

type Card = {
    href: string;
    title: string;
    cta: string;
    image: string;
};

const cards: Card[] = [
    {
        href: "https://sharegate.com/microsoft-migration",
        title: "Move data. Keep your people productive.",
        cta: "Explore ShareGate Microsoft 365 migration",
        image: CardMigrate,
    },
    {
        href: "https://sharegate.com/solutions/tenant-to-tenant-migration",
        title: "Your tenant-to-tenant migration tool.",
        cta: "ShareGate tenant-to-tenant migration tool",
        image: CardTenant,
    },
    {
        href: "https://sharegate.com/blog/microsoft-365-tenant-to-tenant-migration-tools",
        title: "Everything you need before you start.",
        cta: "Microsoft 365 tenant-to-tenant migration guide",
        image: CardGuide,
    },
    {
        href: "https://sharegate.com/category/migration",
        title: "Real migrations. Real lessons.",
        cta: "Read ShareGate migration articles",
        image: CardLessons,
    },
    {
        href: "https://help.sharegate.com/en/",
        title: "When you need the details, we’ve got them.",
        cta: "ShareGate documentation for IT specialists",
        image: CardDocs,
    },
    {
        href: "https://sharegate.com/partner",
        title: "Grow your practice with ShareGate.",
        cta: "Become a ShareGate partner",
        image: CardPartner,
    },
];

export const MigrationCards = () => (
    <section className="cards-section">
        <div className="cards-section__header">
            <h2 className="cards-section__title">Planning a migration? Start here.</h2>
            <p className="cards-section__sub">Resources from ShareGate for Microsoft 365 admins and partners.</p>
            <a
                className="cta-banner__btn cards-section__btn"
                href="https://sharegate.com/demo?utm_source=whatismytenantid&utm_campaign=whatismytenantid&utm_medium=bloc&utm_content=demo-cards"
                target="_blank"
                rel="noreferrer"
            >
                Request a demo
            </a>
        </div>
        <div className="cards-grid">
            {cards.map((c, i) => (
                <a key={i} className="mig-card" href={c.href} target="_blank" rel="noreferrer">
                    <div className="mig-card__visual">
                        <img src={c.image} alt="" loading="lazy" />
                    </div>
                    <h3 className="mig-card__title">{c.title}</h3>
                    <span className="mig-card__cta">{c.cta} →</span>
                </a>
            ))}
        </div>
    </section>
);
